import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

export const Services = ({ t }) => (
  <section id="services" data-testid="services-section" className="relative py-24 lg:py-32 bg-[#F1F2F4]">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <Reveal>
        <SectionLabel testid="services-label">{t.services.label}</SectionLabel>
        <h2 data-testid="services-title" className="font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#0B132B] mb-16">
          {t.services.title}
        </h2>
      </Reveal>

      <div className="border-t border-[#0B132B]/10">
        {t.services.chapters.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`service-chapter-${c.n}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className="group grid md:grid-cols-12 gap-6 md:gap-10 items-start py-10 lg:py-14 border-b border-[#0B132B]/10 hover:bg-white/70 transition-colors px-2 sm:px-4"
          >
            <div className="md:col-span-2 font-display italic text-5xl lg:text-6xl text-[#C5A059] group-hover:text-[#8C713A] transition-colors">
              {c.n}
            </div>
            <div className="md:col-span-5">
              <h3 className="font-display text-3xl lg:text-4xl font-medium text-[#0B132B] flex items-center gap-3">
                {c.title}
                <ArrowUpRight size={22} className="text-[#C5A059] opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
              </h3>
              <p className="mt-3 text-slate-500 font-light leading-relaxed max-w-md">{c.desc}</p>
            </div>
            <ul className="md:col-span-5 grid sm:grid-cols-2 gap-x-8 gap-y-3">
              {c.items.map((item, j) => (
                <li key={j} className="flex items-start gap-3 text-sm text-slate-600">
                  <span className="mt-1.5 h-1 w-1 rounded-full bg-[#C5A059] shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
